export default __webpack_public_path__ + "static/media/howsell-3.c9c1f956.svg";